var _effectorFileName = "/builds/gmini/front-ui-kit/src/FormulaInput/Element.tsx";
import { Cross } from '../icons';
import { Tooltip } from './../Tooltip';
import { DeleteButton, CrossWrapper, Bubble, BubbleText, BubbleWrapper } from './Element.styled';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const Element = props => {
  const {
    attributes,
    children,
    element
  } = props;

  switch (element.type) {
    case 'mention':
      return /*#__PURE__*/_jsx(MentionElement, { ...props
      });

    default:
      return /*#__PURE__*/_jsx("p", { ...attributes,
        children: children
      });
  }
};

const MentionElement = ({
  attributes,
  children,
  element,
  onDelete,
  readonly
}) => {
  const {
    property
  } = element;
  return /*#__PURE__*/_jsxs("span", { ...attributes,
    contentEditable: true,
    children: [/*#__PURE__*/_jsx(Tooltip, {
      placement: "top",
      title: property.onlyInFormula ? 'Свойство отсутствует в дереве' : '',
      styleContent: {
        display: 'inline-block'
      },
      children: /*#__PURE__*/_jsx(BubbleWrapper, {
        children: /*#__PURE__*/_jsxs(Bubble, {
          error: property.onlyInFormula,
          children: [/*#__PURE__*/_jsxs(BubbleText, {
            readonly: readonly,
            error: property.onlyInFormula,
            contentEditable: false,
            children: [property.groupName, ".", property.name]
          }), !readonly && /*#__PURE__*/_jsx(DeleteButton, {
            error: property.onlyInFormula,
            onClick: onDelete,
            children: /*#__PURE__*/_jsx(CrossWrapper, {
              children: /*#__PURE__*/_jsx(Cross, {})
            })
          })]
        })
      })
    }), children]
  });
};